import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChatDepotChoice } from '@sabstravtech/obtservices/base';

@Component({
  selector: 'app-chat-depot-list',
  standalone: false,
  templateUrl: './chat-depot-list.component.html',
  styleUrls: ['./chat-depot-list.component.scss']
})
export class ChatDepotListComponent {
  @Input() depots!: ChatDepotChoice[];
  @Output() depotSelect = new EventEmitter<number>();

  select(index: number): void {
    this.depotSelect.emit(index);
  }
}
